import logo from '../files/logo.png'

const Logo = ({ width, height }) => (
  <img width={width} height={height} src={logo} alt='' />
)

export default Logo
